Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundCloud = void 0;

var _react = _interopRequireDefault(require("react"));

var _generalObserver = require("../general-observer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SoundCloud = function SoundCloud(_ref) {
  var soundCloudLink = _ref.soundCloudLink,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
      _ref$visual = _ref.visual,
      visual = _ref$visual === void 0 ? false : _ref$visual,
      color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "soundcloud",
    title: "sound-cloud-".concat(soundCloudLink),
    className: "soundcloud-mdx-embed",
    width: width,
    height: height,
    scrolling: "no",
    frameBorder: "no",
    allow: "autoplay",
    src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/".concat(soundCloudLink, "&color=%23").concat(color, "&auto_play=").concat(autoPlay, "&visual=").concat(visual)
  }));
};

exports.SoundCloud = SoundCloud;